export const PASSWORD_MUST_MATCH = "Passwords do not match";
export const IN_VALID_EMAIL = "Please enter valid email";
export const EMPTY_SEARCH_VALUE = "Please Enter A Value To Search!";
export const INVALID_FILTERS = "Invalid Filter Dates Selected!";
export const NO_FILTERS = "No Filters Selected!";
export const SELECT_FACILITY = "Please Select A Facility First!";
export const DUPLICATION_FAILED = "Failed to copy Layout";
export const IMPERSONATION_FAILED = "Failed To Impersonate User!";
